// Monday 00:00:00 of the week containing `date` (Vietnam convention: week starts Monday).
export const getWeekStart = (date: Date): Date => {
  const start = new Date(date);
  const day = start.getDay(); // 0 = Sunday, 1 = Monday, ...
  const diffToMonday = day === 0 ? -6 : 1 - day;
  start.setDate(start.getDate() + diffToMonday);
  start.setHours(0, 0, 0, 0);
  return start;
};

export const addDays = (date: Date, days: number): Date => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
};

export const formatWeekRangeLabel = (weekStart: Date): string => {
  const weekEnd = addDays(weekStart, 6);
  const fmt = (d: Date) =>
    `${String(d.getDate()).padStart(2, "0")}/${String(
      d.getMonth() + 1
    ).padStart(2, "0")}`;
  return `${fmt(weekStart)} - ${fmt(weekEnd)}/${weekEnd.getFullYear()}`;
};
